import configProvider from "./configProvider"
import SwaggerAuthenClient from "./SwaggerAuthenClient"

const client = new SwaggerAuthenClient({
    url: configProvider.get("IDENTITY_AUTHEN_SERVICE_URL")
})

export default client
